import React from 'react';
import {
  Badge,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from '@mui/material';
import { Link } from 'react-router-dom';

type CardLinkProps = {
  to?: string;
  primary: React.ReactNode;
  secondary: React.ReactNode;
  icon: React.ReactNode;
  showBadge?: boolean;
  badgeColor?: 'info';
};

const CardLink = ({
  to = undefined,
  primary,
  secondary,
  icon,
  showBadge = false,
  badgeColor = 'info',
}: CardLinkProps) => (
  <ListItemButton
    component={to ? Link : 'div'}
    to={to || undefined}
    disableGutters
    sx={{
      textDecoration: 'none',
      color: 'inherit',
      p: 0,
    }}
  >
    <ListItemAvatar>
      <Badge
        invisible={!showBadge}
        color={badgeColor}
        variant="dot"
        overlap="circular"
      >
        <Avatar sx={{ width: 40, height: 40 }}>
          {icon}
        </Avatar>
      </Badge>
    </ListItemAvatar>

    <ListItemText
      primary={primary}
      primaryTypographyProps={{
        variant: 'bodyBold',
        sx: {
          textDecoration: 'none',
        },
      }}
      secondary={secondary}
    />
  </ListItemButton>
);

export default CardLink;
